export const getVTShopManagementClass = (shopId: string, classId: string = "") => ({
  classId: "VT.ShopManagementClass",
  instances: [
    {
      enabled: true,
      id: classId,
      values: [
        {
          technicalName: "shopId",
          value: shopId,
        },
      ],
    },
  ],
});
